module.exports = __webpack_public_path__ + "static/media/KARAN ACOUSTICS MASTER COLLECTION PHONO B.96c42ec5.png";